<div
    role="button"
    (click)="navigate()"
    class="d-flex align-items-center">
    <span
        class="padding-1 primary-gradient-bg-300 m-2 clip3">
         <span class="font-4 d-flex clip3 position-relative secondary-bg-200  primary-text-100 primary-border corner py-1 px-4">
            <ng-content></ng-content>
        </span>
    </span>
    <ng-content select="[icon]"></ng-content>
</div>